import { API_URL, PRICE_SCHEME_HEADER, Status } from '../constants';
import { fetch } from '../fetchWrapper/fetch';

export type Price = NewPrice | ExistingPrice;

interface Common {
  item_id?: string;
}

interface NewPrice extends Common {
  price_id: null;
  modifier_id?: string;
  extension_instance_id: string | null;
  price_band_id: string | null;
  value_with_tax: number | null;
}

interface ExistingPrice extends Common {
  price_id: string;
  modifier_id?: string;
  extension_instance_id: string | null;
  price_band_id: string | null;
  value_with_tax: number | null; // null deletes price entity
}

export const updateProductsPricing = async (priceSchemeId: string, payload: Price[]) => {
  const res = await fetch(`${API_URL}/pricing/product-prices`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      [PRICE_SCHEME_HEADER]: priceSchemeId,
    },
    body: JSON.stringify({ prices: payload }),
  });
  if (res.status !== Status.NO_CONTENT) {
    const body = await res.json().catch(() => null);
    throw new Error(typeof body?.message === 'string' ? body.message : 'Something went wrong updating pricing');
  }
};
